import { useNavigate } from "react-router-dom";
import "../App.css";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="empty-result">
      <h1 className="text-hero">
        Who Would <span className="hero-accent">Win</span>
      </h1>
      <h2 className="empty-result-title">Page Not Found</h2>
      <p className="empty-result-sub">
        That page doesn't exist. Pick your fighters and let the AI decide who wins.
      </p>
      <button className="fight-btn" style={{ maxWidth: 320 }} onClick={() => navigate("/")}>
        Start a Battle
      </button>
    </div>
  );
}
